import React from "react";

export interface ErrorModalProps {
  message?: string;
  onCancel?: () => void;
  onContinue?: () => void;
  onClose?: () => void;
  cancelText?: string;
  continueText?: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  message = 'Our system has encountered an unfortunate error which we cannot seem to automatically resolve. To try again, press "Continue." For assistance please contact our customer service team.',
  onCancel,
  onContinue,
  onClose,
  continueText = "CONTINUE",
  cancelText = "CANCEL",
}) => {
  return (
    <div className="absolute left-0 top-0 z-50 flex h-[100%] w-[100%] items-center justify-center">
      <div className="absolute left-0 top-0 h-[100%] w-[100%] bg-white opacity-50" />
      <div className="relative -mt-[100px] flex w-full max-w-[600px] flex-col items-center rounded-none bg-white px-10 pb-7 pt-12 font-sans shadow-lg before:absolute before:left-0 before:top-0 before:h-[50px] before:w-full before:bg-gray">
        {/* Close Button */}
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute right-5 top-2 cursor-pointer border-none bg-none text-[32px] leading-none text-white"
        >
          &times;
        </button>
        {/* Message */}
        <div
          className="mb-4 mt-7 text-center font-normal text-gray100"
          dangerouslySetInnerHTML={{ __html: message }}
        />
        {/* Buttons */}
        <div className="mt-4 flex gap-8">
          {onCancel ? (
            <button
              onClick={onCancel}
              className="w-[130px] cursor-pointer rounded-none border-none bg-gray300 font-normal text-white [text-shadow:2px_2px_0_#969696]"
            >
              {cancelText}
            </button>
          ) : null}
          {onContinue ? (
            <button
              onClick={onContinue}
              className="w-[130px] cursor-pointer rounded-none border-none bg-green200 py-3 tracking-wider text-white [text-shadow:2px_2px_0_#15764c]"
            >
              {continueText}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
